import { render, staticRenderFns } from "./dependent-competencies.vue?vue&type=template&id=7490660d&scoped=true"
import script from "./dependent-competencies.ts?vue&type=script&lang=ts&external"
export * from "./dependent-competencies.ts?vue&type=script&lang=ts&external"
import style0 from "./dependent-competencies.scss?vue&type=style&index=0&id=7490660d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7490660d",
  null
  
)

export default component.exports